import { Matiere, COEF_OPTION1, COEF_OPTION2 } from '../types/main';

// épreuves anticipées
export const COEF_FRANCAIS_ECRIT = 3;
export const COEF_FRANCAIS_ORAL = 2;
export const COEF_SCIENCES = 2;
export const COEF_TPE = 2;

// contrôle continu
export const COEF_SPE_4 = 4;
// export const COEF_SPE_3_3_ORAL = 3;
export const COEF_SPE_3_3_ECRIT = 6;

export const COEF_LITT = 4;
export const COEF_HG = 4;
export const COEF_LV1 = 4;
export const COEF_LV1_SISPE = 8;
export const COEF_LV2 = 4; 
export const COEF_LV2_SISPE = 8;
export const COEF_LITT_ETR = 1;
export const COEF_PHILO = 7;
export const COEF_EPS = 2;

export const COEF_EPS_COMP = 2;

export const listeSpesL = [
  'Langues et cultures de l\'antiquité: latin',
  'Langues et cultures de l\'antiquité: grec',
  'LV1 approfondie',
  'LV2 approfondie',
  'Langue vivante 3',
  'Mathématiques',
  'Droits et grands enjeux du monde contemporain',
  'Arts plastiques',
  'Cinéma-audiovisuel',
  'Histoire des arts',
  'Musique',
  'Théâtre',
  'Danse',
  'Arts du cirque',
];
// sous filières
// export const SOUS_FILIERES

export const matieres_EA_L = [
  {
    name: 'francais_ecrit',
    label: 'Français et Littérature  Ecrit',
    coef: COEF_FRANCAIS_ECRIT,
  },
  {
    name: 'francais_oral',
    label: 'Français et Littérature  Oral',
    coef: COEF_FRANCAIS_ORAL,
  },
  {
    name: 'TPE',
    label: 'TPE',
    coef: COEF_TPE,
    pointsAuDessus10: true,
  },
  {
    name: 'sciences',
    label: 'Sciences',
    coef: COEF_SCIENCES,
  },
] as Matiere[];

export const matieres_L = [
  {
    name: 'spe_l_4',
    label: 'Langues et cultures de l\'antiquité: latin',
    coef: COEF_SPE_4,
  },
  {
    name: 'spe_l_4',
    label: 'Langues et cultures de l\'antiquité: grec',
    coef: COEF_SPE_4,
  },
  {
    name: 'spe_l_4',
    label: 'Langue vivante 3',
    coef: COEF_SPE_4,
  },
  {
    name: 'spe_l_4',
    label: 'Mathématiques',
    coef: COEF_SPE_4,
  },
  {
    name: 'spe_l_4',
    label: 'Droits et grands enjeux du monde contemporain',
    coef: COEF_SPE_4,
  },
  {
    name: 'spe_l_3_3',
    label: 'Arts plastiques',
    coef: COEF_SPE_3_3_ECRIT,
  },
  {
    name: 'spe_l_3_3',
    label: 'Cinéma-audiovisuel',
    coef: COEF_SPE_3_3_ECRIT,
  },
  {
    name: 'spe_l_3_3',
    label: 'Histoire des arts',
    coef: COEF_SPE_3_3_ECRIT,
  },
  {
    name: 'spe_l_3_3',
    label: 'Musique',
    coef: COEF_SPE_3_3_ECRIT,
  },
  {
    name: 'spe_l_3_3',
    label: 'Théâtre',
    coef: COEF_SPE_3_3_ECRIT,
  },
  {
    name: 'spe_l_3_3',
    label: 'Danse',
    coef: COEF_SPE_3_3_ECRIT,
  },
  {
    name: 'spe_l_3_3',
    label: 'Arts du cirque',
    coef: COEF_SPE_3_3_ECRIT,
  },
  {
    name: 'litt',
    label: 'Littérature',
    coef: COEF_LITT,
  },
  {
    name: 'hist_geo',
    label: 'Histoire - Géographie',
    coef: COEF_HG,
  },
  {
    name: 'LV1',
    label: 'LV1',
    coef: COEF_LV1,
  },
  {
    name: 'LV2',
    label: 'LV2',
    coef: COEF_LV2,
  },
  {
    name: 'litt_etr',
    label: 'Littérature étrangère',
    coef: COEF_LITT_ETR,
  },
  {
    name: 'philo',
    label: 'Philosophie',
    coef: COEF_PHILO,
  },
  {
    name: 'EPS',
    label: 'EPS',
    coef: COEF_EPS,
  },
  {
    name: 'EPS_comp',
    label: 'EPS de complément',
    coef: COEF_EPS_COMP,
  },
] as Matiere[];
